// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_iv-0";
export var animationContainer = "_iv-1";
export var itemPrice = "_iv-a";
export var itemizedContent = "_iv-9";
export var itemizedHeader = "_iv-7";
export var itemizedRow = "_iv-8";
export var itemizedSection = "_iv-6";
export var modalContent = "_iv-2";
export var orderName = "_iv-3";
export var refundOption = "_iv-4";
export var refundOptionsContainer = "_iv-5";
export var shippingLabel = "_iv-b";
export var totalRow = "_iv-c";